export enum CoachApplicationStatus {
    PENDING = 'PENDING',
    DECLINED = 'DECLINED',
    APPROVED = 'APPROVED',
    AMENDED = 'AMENDED'
}